// client/src/ui/Router.js

// --- SCREEN IMPORTS (Lazy Loading Implementation) ---
import { CategoryScreen } from '../components/screens/CategoryScreen.js';
import { GundemScreen } from '../components/screens/GundemScreen.js';
import { LobbyScreen } from '../components/screens/LobbyScreen.js';
import { WaitingRoomScreen } from '../components/screens/WaitingRoomScreen.js';
import { ModeScreen } from '../components/screens/ModeScreen.js';
import { DifficultyScreen } from '../components/screens/DifficultyScreen.js';
import { GameScreen } from '../components/screens/GameScreen.js';
import { ResultScreen } from '../components/screens/ResultScreen.js';
import { WheelScreen } from '../components/screens/WheelScreen.js';
import { AboutScreen } from '../components/screens/AboutScreen.js';
import { ContactScreen } from '../components/screens/ContactScreen.js';
import { FaqScreen } from '../components/screens/FaqScreen.js';
import { ExamsScreen } from '../components/screens/ExamsScreen.js';
import { LogScreen } from '../components/screens/LogScreen.js';
import { MythologyScreen } from '../components/screens/MythologyScreen.js';
import { AtaturkCornerScreen } from '../components/screens/AtaturkCornerScreen.js';
import { KanitTemelliScreen } from '../components/screens/KanitTemelliScreen.js';
import { EtkinlikKitapScreen } from '../components/screens/EtkinlikKitapScreen.js';


import historyData from '../data/history_data.js';

// Screen Factory Map
const ScreenMap = {
    'category-screen': CategoryScreen,
    'gundem-screen': GundemScreen,
    'lobby-screen': LobbyScreen,
    'waiting-room-screen': WaitingRoomScreen,
    'mode-screen': ModeScreen,
    'difficulty-screen': DifficultyScreen,
    'game-screen': GameScreen,
    'result-screen': ResultScreen,
    'wheel-screen': WheelScreen, // Note: WheelScreen ID might differ in HTML, usually 'wheel-screen'
    'about-screen': AboutScreen,
    'contact-screen': ContactScreen,
    'faq-screen': FaqScreen,
    'exams-screen': ExamsScreen,
    'log-screen': LogScreen,
    'mythology-screen': MythologyScreen,
    'ataturk-corner-screen': AtaturkCornerScreen,
    'kanit-temelli-screen': KanitTemelliScreen,
    'etkinlik-kitap-screen': EtkinlikKitapScreen
};

function getDailyHistoryData() {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const key = `${month}-${day}`;
    // Fallback to default if specific date not found
    let entry = historyData[key] || historyData["default"];

    // [FIX] If entry is an array, pick the first one or random one to avoid "undefined" title
    if (Array.isArray(entry)) {
        if (entry.length === 0) return historyData["default"];
        // Return first one to keep it stable during one session
        return entry[0];
    }

    return entry;
}

window.Router = {
    // URL Eşleşmeleri
    routes: {
        'category-screen': '/',
        'lobby-screen': '/lobi',
        'game-screen': '/oyun',
        'result-screen': '/sonuc',
        'about-screen': '/hakkimda',
        'contact-screen': '/iletisim',
        'faq-screen': '/sss',
        'gundem-screen': '/gundem',
        'mode-screen': '/oyun-kurulum/mod',
        'difficulty-screen': '/oyun-kurulum/zorluk',
        'waiting-room-screen': '/bekleme-odasi',
        'exams-screen': '/sinavlar',
        'log-screen': '/logs',
        'mythology-screen': '/mitoloji',
        'ataturk-corner-screen': '/ataturk-kosesi',
        'kanit-temelli-screen': '/kanit-temelli-tarih',
        'etkinlik-kitap-screen': '/kanit-temelli-tarih/selcuklu'
    },

    // Route -> Screen ID (Ters Eşleşme ve Parametre Çözümleme)
    getScreenIdFromPath: function (path) {
        console.log(`[Router] getScreenIdFromPath called with: "${path}"`);

        // Query paramları temizle ve normalize et
        let cleanPath = path.split('?')[0];
        if (cleanPath.endsWith('/') && cleanPath.length > 1) cleanPath = cleanPath.slice(0, -1);
        cleanPath = cleanPath.toLowerCase();

        // 1. Tam Eşleşme Kontrolü
        for (const [id, route] of Object.entries(this.routes)) {
            if (route.toLowerCase() === cleanPath) {
                return id;
            }
        }

        // 2. Dinamik Eşleşme (Deep Linking)
        if (cleanPath === '/lobi/kur') {
            this.updateStateFromUrl({ lobbyAction: 'create' });
            return 'lobby-screen';
        }
        else if (cleanPath === '/lobi/katil') {
            this.updateStateFromUrl({ lobbyAction: 'join' });
            return 'lobby-screen';
        }
        else if (cleanPath.startsWith('/oyun-kurulum/mod/')) {
            const category = cleanPath.split('/')[3];
            if (category) {
                this.updateStateFromUrl({ currentCategory: category });
                return 'mode-screen';
            }
        }
        else if (cleanPath.startsWith('/oyun-kurulum/zorluk/')) {
            const parts = cleanPath.split('/');
            const category = parts[3];
            const mode = parts[4];
            if (category) {
                const updates = { currentCategory: category };
                if (mode === 'sureli') updates.isTimedMode = true;
                else if (mode === 'ozgur') updates.isTimedMode = false;
                this.updateStateFromUrl(updates);
                return 'difficulty-screen';
            }
        }
        else if (cleanPath.startsWith('/oyun/')) {
            const category = cleanPath.split('/')[2];
            if (category) {
                this.updateStateFromUrl({ currentCategory: category });
                return 'game-screen';
            }
        }

        console.log(`[Router] No match found. Defaulting to 'category-screen'`);
        return 'category-screen';
    },

    updateStateFromUrl: function (updates) {
        if (!window.state) window.state = {};
        Object.assign(window.state, updates);
    },

    // --- SEO & METADATA MANAGEMENT ---
    metaMap: {
        'category-screen': { title: 'GADDAR BİLGİ - Ana Menü', desc: 'Genel Kültür ve Bilgi Yarışması. Hemen oyna ve bilgini test et!' },
        'lobby-screen': { title: 'Lobi | GADDAR BİLGİ', desc: 'Online oyun lobisine katıl, arkadaşlarınla yarış.' },
        'game-screen': { title: 'Oyun Ekranı | GADDAR BİLGİ', desc: 'Zorlu sorularla mücadele et.' },
        'result-screen': { title: 'Sonuçlar | GADDAR BİLGİ', desc: 'Oyun sonuçlarını gör ve puanını paylaş.' },
        'gundem-screen': { title: 'Gündem Modu | GADDAR BİLGİ', desc: 'Türkiye ve Dünya gündeminden güncel sorular.' },
        'ataturk-corner-screen': { title: 'Atatürk Köşesi | GADDAR BİLGİ', desc: 'Ulu Önder Atatürk hakkında bilgiler ve testler.' },
        'default': { title: 'GADDAR BİLGİ', desc: 'Gaddar Bilgi Yarışması' }
    },

    updateMeta: function (screenId) {
        let meta = this.metaMap[screenId] || this.metaMap['default'];

        // [DYNAMIC METADATA] Override for Home Screen with Daily History
        if (screenId === 'category-screen') {
            const dailyData = getDailyHistoryData();
            if (dailyData) {
                meta = {
                    title: `GADDAR BİLGİ - ${dailyData.title}`,
                    desc: `GADDAR BİLGİ. ${dailyData.year} | (${dailyData.title}). ${dailyData.text}`
                };
            }
        }

        document.title = meta.title;

        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.name = "description";
            document.head.appendChild(metaDesc);
        }
        metaDesc.content = meta.desc;
    },

    // Uygulamayı başlatır
    init: function () {
        const path = window.location.pathname;
        const initialScreen = this.getScreenIdFromPath(path);
        this.showScreen(initialScreen, false);

        window.addEventListener('popstate', (event) => {
            const newPath = window.location.pathname;
            const targetScreen = this.getScreenIdFromPath(newPath);
            this.showScreen(targetScreen, false);
        });
    },

    /**
     * Ekran geçişlerini yönetir (DYNAMIC RENDERING OPTIMIZED)
     */
    showScreen: function (screenId, updateHistory = true, isOnlineOverride = false) {
        // [GÜVENLİK/STATE KONTROLLERİ]
        if (screenId === 'difficulty-screen') {
            if (!window.state || !window.state.currentCategory) {
                screenId = 'category-screen';
            }
        }
        else if (screenId === 'lobby-screen') {
            if (window.onlineManager) {
                window.onlineManager.init();
                window.onlineManager.switchPanel('main', false);
                if (window.LobbyManager) {
                    setTimeout(() => window.LobbyManager.refreshServerList(), 500);
                }
            }
        }
        else if (screenId === 'waiting-room-screen') {
            const hasRoom = (window.multiplayer && window.multiplayer.room) ||
                (window.MatchmakingManager && window.MatchmakingManager.currentRoom);
            if (!hasRoom) {
                screenId = 'lobby-screen';
                return this.showScreen(screenId, updateHistory, isOnlineOverride);
            }
        }
        else if (screenId === 'mode-screen') {
            if (!window.state || !window.state.currentCategory) {
                screenId = 'category-screen';
            } else if (!window.state.currentDifficulty) {
                screenId = 'difficulty-screen';
            }
        }
        else if (screenId === 'game-screen') {
            const isOnline = isOnlineOverride ||
                (window.multiplayer && window.multiplayer.room) ||
                (window.MatchmakingManager && window.MatchmakingManager.currentRoom);
            if (!isOnline) {
                if (!window.state || !window.state.activeQuestions || window.state.activeQuestions.length === 0) {
                    screenId = 'category-screen';
                }
            }
        }
        else if (screenId === 'result-screen') {
            if (!window.state || !window.state.activeQuestions || window.state.activeQuestions.length === 0) {
                screenId = 'category-screen';
            }
        }
        else if (screenId === 'log-screen') {
            const isAdmin = window.AuthManager && window.AuthManager.isAdmin();
            if (isAdmin) {
                if (window.initLogScreen) window.initLogScreen();
            } else {
                screenId = 'category-screen';
                if (window.utils && window.utils.showToast) {
                    window.utils.showToast("Bu sayfaya erişim yetkiniz yok!", "error");
                }
            }
        }

        // --- DYNAMIC RENDERING LOGIC ---
        // 1. Ekran DOM'da var mı kontrol et
        const gameContainer = document.getElementById('game-container');
        let target = document.getElementById(screenId);

        if (!target) {
            console.log(`[Router] Rendering screen dynamically: ${screenId}`);
            const screenFactory = ScreenMap[screenId];
            if (screenFactory) {
                const screenHTML = screenFactory();
                if (gameContainer) {
                    gameContainer.insertAdjacentHTML('beforeend', screenHTML);
                    target = document.getElementById(screenId);

                    // Eğer target ID, factory'den gelen HTML içindeki ID ile uyuşmuyorsa (örn. wheel-screen vs wheel-div)
                    // Genelde uyuşur ama manuel kontrol:
                    if (!target) {
                        // En son eklenen div'i bulmaya çalış veya factory'lerin doğru ID döndürdüğünden emin ol.
                        // Şimdilik factory'lerin doğru ID döndürdüğünü varsayıyoruz. 
                        // Hata durumunda loglayalım.
                        const lastChild = gameContainer.lastElementChild;
                        if (lastChild && lastChild.classList.contains('screen')) {
                            target = lastChild;
                            // ID mismatch fix (optional)
                            if (target.id !== screenId) console.warn(`[Router] ID mismatch! Requested: ${screenId}, Created: ${target.id}`);
                        }
                    }
                }
            } else {
                console.error(`[Router] Screen Factory not found for: ${screenId}`);
                return; // Kritik hata
            }
        }

        // 2. Tüm ekranları gizle
        // Sadece DOM'da OLAN ekranları gizle (Performance Gain)
        const visibleScreens = document.querySelectorAll('.screen.active');
        visibleScreens.forEach(s => s.classList.remove('active'));

        // 3. Hedef ekranı göster
        if (target) {
            target.classList.add('active');
            window.scrollTo({ top: 0, behavior: 'instant' });
            if (target.scrollTop !== undefined) target.scrollTop = 0;
        } else {
            console.error(`[Router] Failed to render or find screen: ${screenId}`);
            return;
        }

        // --- POST-RENDER LOGICK ---

        // Oyun Modu Class
        if (screenId === 'game-screen') {
            document.body.classList.add('game-mode-active');
        } else {
            document.body.classList.remove('game-mode-active');
        }

        // Chat Cleanup
        const allowedScreens = ['waiting-room-screen', 'game-screen'];
        if (!allowedScreens.includes(screenId)) {
            if (window.ChatManager) window.ChatManager.destroy();
        }

        // [FIX] Wheel Cleanup - Çark ekranından çıkınca sesi ve animasyonu durdur
        if (screenId !== 'wheel-screen') {
            if (window.wheel && window.wheel.exit) {
                window.wheel.exit();
            }
        }

        // Main Menu Class
        if (screenId === 'category-screen') {
            document.body.classList.add('main-menu-active');
            
            // Eğer müzik durmuşsa fakat genel ayar (mute) açık değilse, menü müziğini başlat
            if (window.audio && window.audio.backgroundMusic && window.audio.backgroundMusic.paused && !window.audio.isMuted) {
                // Şayet genel müzik modu customsa veya varsayılansa çalması için forcePlay veya play denenebilir
                window.audio.backgroundMusic.play().catch(e => console.warn("Menü müziği çalınamadı", e));
            }
        } else {
            document.body.classList.remove('main-menu-active');
        }

        // History Update
        if (updateHistory) {
            let url = this.routes[screenId];
            if (window.state && window.state.currentCategory) {
                if (screenId === 'mode-screen') url = `/mod-sec/${window.state.currentCategory}`;
                else if (screenId === 'difficulty-screen') {
                    const mode = window.state.isTimedMode ? 'sureli' : 'suresiz';
                    url = `/zorluk-sec/${window.state.currentCategory}/${mode || ''}`;
                }
            }
            // [ENABLED] URL değişimi aktif edildi (SEO ve Paylaşım için)
            if (url) window.history.pushState({ screenId: screenId }, "", url);
        }

        // SEO Update
        this.updateMeta(screenId);

        // Kanit Temelli ve Etkinlik Ekranı Müzik Bypass İşlemi
        if (screenId === 'kanit-temelli-screen' || screenId === 'etkinlik-kitap-screen') {
            if (window.audio && window.audio.backgroundMusic) {
                // Ne olursa olsun buralara girilince arkadaki müzik sussun.
                window.audio.backgroundMusic.pause();
            }
        }

        this.updateBackButton(screenId);
    },

    updateBackButton: function (screenId) {
        const backBtn = document.getElementById('back-btn');
        if (backBtn) {
            // [FIX] User requested back button to be visible even on home/category screen
            backBtn.classList.remove('hidden');
        }
    },

    goBack: function () {
        const activeScreen = document.querySelector('.screen.active');
        if (!activeScreen) return;
        const currentId = activeScreen.id;

        const handleMusicReturn = () => {
            if (window.audio && window.audio.musicMode !== 'custom') {
                audio.playMusic('gaddarin_pesindeyim.mp3', true);
            }
        };

        if (currentId === 'lobby-screen') {
            const createPanel = document.getElementById('create-room-panel');
            const joinPanel = document.getElementById('join-room-panel');
            const lobbyMain = document.getElementById('lobby-main-actions');

            if (createPanel && !createPanel.classList.contains('hidden')) {
                createPanel.classList.add('hidden');
                if (lobbyMain) lobbyMain.classList.remove('hidden');
                return;
            }
            if (joinPanel && !joinPanel.classList.contains('hidden')) {
                joinPanel.classList.add('hidden');
                if (lobbyMain) lobbyMain.classList.remove('hidden');
                return;
            }
            this.showScreen('category-screen');
            return;
        }

        if (currentId === 'waiting-room-screen') {
            if (window.multiplayer && window.multiplayer.leaveRoom) {
                if (window.onlineManager) window.onlineManager.intentionalDisconnect = true;
                window.multiplayer.leaveRoom();
            }
            this.showScreen('lobby-screen');
            return;
        }

        if (currentId === 'difficulty-screen') {
            this.showScreen('category-screen');
            // Re-open category modal if needed
        }
        else if (currentId === 'mode-screen') {
            this.showScreen('difficulty-screen');
        }
        else if (currentId === 'game-screen') {
            if (window.multiplayer && window.multiplayer.room) {
                window.utils.showConfirm("Oyundan çıkmak istediğinize emin misiniz?", () => {
                    window.multiplayer.leaveRoom();
                    this.showScreen('lobby-screen');
                });
                return;
            } else {
                if (window.game) window.game.abortGame();
                handleMusicReturn();
                if (state.currentCategory === 'gundem') this.showScreen('gundem-screen');
                else if (['custom_gaddar', 'custom_week', 'history_today'].includes(state.currentCategory)) this.showScreen('category-screen');
                else this.showScreen('mode-screen');
            }
        }
        else if (currentId === 'gundem-screen' || ['about-screen', 'contact-screen', 'settings-screen', 'faq-screen'].includes(currentId)) {
            this.showScreen('category-screen');
        }
        else if (currentId === 'result-screen') {
            handleMusicReturn();
            if (state.currentCategory === 'gundem') this.showScreen('gundem-screen');
            else if (['custom_gaddar', 'custom_week', 'history_today'].includes(state.currentCategory)) this.showScreen('category-screen');
            else this.showScreen('mode-screen');
        }
        if (currentId === 'ataturk-corner-screen') {
            this.showScreen('category-screen');
        }
        else if (currentId === 'etkinlik-kitap-screen') {
            if (window.EtkinlikKitap && window.EtkinlikKitap.exitBook) {
                window.EtkinlikKitap.exitBook();
            } else {
                this.showScreen('kanit-temelli-screen');
            }
            return;
        }
        else if (currentId === 'kanit-temelli-screen') {
            this.showScreen('category-screen');
        }
        else {
            this.showScreen('category-screen');
        }
    }
};
